export const PACKAGES = [
  {
    id: "bronze",
    name: "Bronze",
    price: 99,
    tagline: "Your story brought to life in music",
    inclusions: [
      "Personal consultation to understand your story and occasion",
      "Original lyrics written specifically for you",
      "Two creative musical directions to preview and choose from (not two finished songs)",
      "Full production and refinement of your chosen song",
      "Completed song delivered digitally in MP3 and WAV formats",
    ],
  },
  {
    id: "silver",
    name: "Silver",
    price: 199,
    tagline: "Your song, beautifully presented",
    inclusions: [
      "Everything included in Bronze",
      "Three creative musical interpretations to preview and choose from",
      "Final editing, refinement and full production",
      "Completed song in MP3 and WAV formats",
      "USB drive in an attractive presentation box",
    ],
  },
  {
    id: "gold",
    name: "Gold",
    price: 299,
    tagline: "The complete premium music experience",
    inclusions: [
      "Everything included in Silver, including the USB presentation box",
      "Closer creative collaboration throughout production",
      "Additional refinements to perfect your song",
      "Bespoke cover artwork and promotional/release artwork",
      "Distribution to major music services, including Spotify and Apple Music/iTunes",
      "Completed song in MP3 and WAV formats",
    ],
  },
];

export const EXTRAS = [
  { id: "artwork", name: "Bespoke song cover / CD-style artwork design", price: 49 },
  { id: "release", name: "Streaming and digital music platform release", price: 29 },
  { id: "physical", name: "Physical CD or additional USB copy (standard postage included)", price: 24 },
  { id: "personalisation", name: "Presentation box personalisation — names, dates or message", price: 15 },
];

export const UPGRADES = [
  { from: "Bronze", to: "Silver", price: 100 },
  { from: "Silver", to: "Gold", price: 100 },
  { from: "Bronze", to: "Gold", price: 200 },
];

export const OCCASIONS = ["Wedding", "Engagement", "Anniversary", "Birthday", "Graduation", "Milestone", "Celebration", "Memorial", "Tribute", "Other"];

export const STEPS = [
  { n: "01", title: "Consultation", text: "We talk through your story, your occasion and the feeling you want the song to carry." },
  { n: "02", title: "Lyrics", text: "Original lyrics are written specifically for you, built around your story." },
  { n: "03", title: "Musical Directions", text: "You preview creative musical directions and choose the one that moves you most." },
  { n: "04", title: "Final Production", text: "Your chosen song is fully produced, refined and polished in the studio." },
  { n: "05", title: "Delivery", text: "Your completed song arrives in MP3 and WAV — presented beautifully on Silver and Gold packages in presentation box." },
];
